export const HistoryList = ({ title, data, renderItem, onItemClick, info }) => {
    const formatDate = (dateString) => {
        if (!dateString) return "";
        return new Date(dateString).toLocaleDateString("pt-BR", { timeZone: 'America/Sao_Paulo' });
    };

    const groupedData = data.reduce((groups, item) => {
        const rawDate = item.purchase_date || item.transactionDate;
        const dateKey = formatDate(rawDate);

        if (!groups[dateKey]) {
            groups[dateKey] = [];
        }
        groups[dateKey].push(item);
        return groups;
    }, {});

    Object.values(groupedData).forEach((items) => {
        items.sort((a, b) => new Date(a.purchase_date || a.transactionDate) - new Date(b.purchase_date || b.transactionDate));
    });

    return (
        <div className="h-full rounded-lg border-2 border-slate-100 shadow-lg flex flex-col">
            <div className="bg-gray-50 px-4 py-2 border-b border-gray-200 flex justify-between items-center">
                <h3 className="font-semibold text-gray-700">Histórico</h3>
                <span className="text-xs text-gray-400">{data.length} registros</span>
            </div>
            <div className="w-full text-xs p-2 font-medium text-custom_gray_font flex-1 overflow-y-auto pr-2">
                {data.length === 0 ? (
                    <div className="flex items-center justify-center border-slate-200 my-1 p-1 px-2 h-full">
                        <p className="font-medium text-base text-center text-gray-400">
                            Não há registros.
                        </p>
                    </div>
                ) : (
                    Object.keys(groupedData)
                        .sort((a, b) => {
                            const [dayA, monthA, yearA] = a.split('/');
                            const [dayB, monthB, yearB] = b.split('/');
                            const dateA = new Date(`${yearA}-${monthA}-${dayA}`);
                            const dateB = new Date(`${yearB}-${monthB}-${dayB}`);
                            return dateB - dateA;
                        })
                        .map((date) => (
                            <div key={date} className="mb-4">
                                <div className="bg-slate-100 text-slate-600 font-bold px-3 py-1.5 rounded-md mb-2 text-sm sticky top-0 z-10 shadow-sm">
                                    {date}
                                </div>
                                <div className="space-y-1">
                                    {groupedData[date].map((item, index) => (
                                        <div
                                            className="flex items-center justify-between border border-slate-100 rounded-lg p-3 cursor-pointer hover:bg-slate-50 transition-colors hover:border-slate-300 hover:shadow-sm"
                                            key={`${item.transactionId || item.order_id}-${index}`}
                                            onClick={() => onItemClick && onItemClick(item)}
                                        >
                                            {renderItem(item)}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))
                )}
            </div>
        </div>
    );
};